/*
  bf_retreatUtils.ts
  Copyright (c) 2024-present Human Cube Inc.
*/

import BF from "../bfconst1";
import { Game } from "../gameTypes";


export function doRetreatValuesCleanUp (game: Game) {
  // Scans through all forces and sets retreat to 0 for any that are no longer able to retreat.
  // Should be called after all zone ownership changes have been applied.

  for(let playerIndex = 0; playerIndex <= game.players; playerIndex++) {  // All players and 0.
    const len = game.force[playerIndex].length;
    for(let j = 0; j < len; j++) {
      const force = game.force[playerIndex][j];
      const retreatZoneID = force[BF.FORCE_INDEX_ZONE_RETREAT];
      if(retreatZoneID === 0) {
        continue;
      }

      const zoneID = force[BF.FORCE_INDEX_ZONE];
      const allyBits = game.fixedAlly[playerIndex];

      if(game.zoneOwner[zoneID] && (1 << game.zoneOwner[zoneID]) & allyBits) {
        force[BF.FORCE_INDEX_ZONE_RETREAT] = 0;  // Cannot retreat from own or ally zones.
        continue;
      }

      if(game.zoneOwner[retreatZoneID] && !((1 << game.zoneOwner[retreatZoneID]) & allyBits)) {
        force[BF.FORCE_INDEX_ZONE_RETREAT] = 0;  // Cannot retreat back to an enemy zones.
        continue;
      }
    }
  }
}
